<template>
  <div class="metric-overview">
    <div v-for="item in data" :key="item.title" class="metric-card">
      <div class="metric-icon">{{ item.icon }}</div>
      <div class="metric-title">{{ item.title }}</div>
      <div class="metric-value">
        <strong>{{ item.value }}</strong>
        <span>{{ item.unit }}</span>
      </div>
      <div class="metric-desc" :class="{ warn: item.warn }">{{ item.desc }}</div>
    </div>
  </div>
</template>

<script setup>
import { overallAverage, priceProducts } from "./priceData";

const data = [
  { icon: "◎", title: "监控商品SKU", value: "2860", unit: "款", desc: "覆盖10类重点农产" },
  { icon: "▤", title: "全县农产综合均价", value: overallAverage().toFixed(2), unit: "元", desc: "今日波动 +1.20元", warn: true },
  { icon: "▱", title: "跨平台平均价差率", value: "14.8", unit: "%", desc: "按同款最低/最高价计算" },
  { icon: "↗", title: "今日价格异动预警", value: "8", unit: "条", desc: "含高价偏离/低价倾销" },
  { icon: "◉", title: "异常数值活跃商户", value: "126", unit: "家", desc: "含直播/店铺" },
  { icon: "⌂", title: "重点监测品类", value: String(priceProducts.length), unit: "类", desc: "黄姜/花生/红薯等" },
];
</script>

<style lang="less" scoped>
.metric-overview {
  height: 100%;
  padding: 34px 22px 24px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
}

.metric-card {
  position: relative;
  overflow: hidden;
  border: 2px solid rgba(43, 174, 255, 0.74);
  border-radius: 6px;
  background: linear-gradient(180deg, rgba(11, 69, 137, 0.65), rgba(8, 42, 95, 0.4));
  box-shadow: inset 0 0 30px rgba(38, 153, 238, 0.16);
  padding: 24px 18px 18px;
  box-sizing: border-box;
}
.metric-card:before,
.metric-card:after {
  content: "";
  position: absolute;
  left: 28px;
  right: 28px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(59, 205, 255, 0.85), transparent);
}

.metric-card:before {
  top: 8px;
}

.metric-card:after {
  bottom: 12px;
}

.metric-icon {
  color: #70d6ff;
  font-size: 40px;
  line-height: 32px;
}
.metric-card:first-child .metric-icon{
    font-size: 60px;
}
.metric-title {
  color: #cfefff;
  font-size: 22px;
  line-height: 34px;
  margin-top: 6px;
  font-weight: bold;
}

.metric-value {
  margin-top: 28px;
  color: #cfeaff;
  white-space: nowrap;
}

.metric-value strong {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 62px;
  line-height: 76px;
  font-weight: bold;
   background: linear-gradient(to bottom, #9CFFFE, #34D0F1 );
  -webkit-background-clip: text;
  color: transparent;
}

.metric-value span {
  font-size: 26px;
  font-weight: bold;
  margin-left: 6px;
}

.metric-card:nth-child(2) .metric-value strong {
  color: #ff7d91;
}

.metric-desc {
  color: #d9edff;
  font-size: 21px;
  line-height: 30px;
  margin-top: 18px;
  font-weight: bold;
}

.metric-desc.warn {
  color: #ff90a5;
}
</style>
